import { render, staticRenderFns } from "./ExtractNumView.vue?vue&type=template&id=8fa2e87c"
import script from "./ExtractNumView.vue?vue&type=script&lang=js"
export * from "./ExtractNumView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports